import React from 'react'
import { StyledJobOffersSlider } from './styled'
import { API } from 'javascripts/api'

export const getFetauredJobOffers = async () => {
  const response = await API.apiV1UsersTopFeaturedJobOffersGet()

  return response.data
}

export const JobOffersSlider: React.FC = () => {
  const [featuredJobOffers, setFeaturedJobOffers] = React.useState([])

  React.useEffect(() => {
    getFetauredJobOffers().then(jobOffers => {
      setFeaturedJobOffers(jobOffers)
    })
  }, [])

  return <StyledJobOffersSlider featuredJobOffers={featuredJobOffers} />
}
